import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/ingreso/getMetodosPago.php';

export default function getMetodosPago(){
    return $.ajax({
        url: URL_API,
        type: 'GET'
    })
}